export const FETCH_CONDITIONS_ESTIMATE = 'FETCH_CONDITIONS_ESTIMATE';

export const fetchConditionsEstimate = conditions => ({
  type: FETCH_CONDITIONS_ESTIMATE,
  payload: { conditions },
});
